"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var kendo_draggable_1 = require("@telerik/kendo-draggable");
/** @hidden */
function useDraggable(ref, _a) {
    var onPress = _a.onPress, onDrag = _a.onDrag, onRelease = _a.onRelease;
    var draggable = React.useMemo(function () { return new kendo_draggable_1.default({
        press: onPress,
        drag: onDrag,
        release: onRelease
    }); }, []);
    var initDraggable = function () {
        var element = ref.current;
        if (!element) {
            return;
        }
        draggable.bindTo(element);
        return function () { draggable.destroy(); };
    };
    var updateDraggable = function () {
        draggable.update({
            press: onPress,
            drag: onDrag,
            release: onRelease
        });
    };
    React.useEffect(initDraggable, []);
    React.useEffect(updateDraggable, [onPress, onDrag, onRelease]);
}
exports.useDraggable = useDraggable;
//# sourceMappingURL=useDraggable.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-common@3.18.0_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@progress/kendo-react-common/dist/npm/hooks/useDraggable.js
// module id = 6469
// module chunks = 0